
import {  Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";

import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

import Dashboard from "./pages/Dashboard";
import EmailTemplates from "./pages/EmailTemplates";
import EmailTemplateEditor from "./pages/EmailTemplateEditor";
import Login from "./pages/Login";

import "./App.css";
import Layout from "./components/Layout";
import PublicRoute from "./components/PublicRoute";
import NotFound from "./pages/NotFound";
import Settings from "./pages/Settings";

const theme = createTheme();
function _AuthRouteWrapper(Component) {

  return (
    <>
      <ProtectedRoute>
        <Layout>{Component} </Layout>
      </ProtectedRoute>
    </>
  );
}
function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          <Route path="/" element={_AuthRouteWrapper(<Dashboard />)} />
          <Route
            path="/emailtemplates"
            element={_AuthRouteWrapper(<EmailTemplates />)}
          />

          <Route
            path="/email-template-editor/:id"
            element={_AuthRouteWrapper(<EmailTemplateEditor />)}
          />
          <Route
            path="/settings"
            element={_AuthRouteWrapper(<Settings />)}
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
